<!--LOADING-->
<ng-template [ngIf]="isLoading">
  <app-loading-page></app-loading-page>
</ng-template>
<!--END LOADING-->
<!--DASHBOARD PAGE-->
<ng-template [ngIf]="!isLoading">
  <div class="dashboard">
    <section class="dashboard-summary">
      <div class="wrapper">
        <!--USER DASHBOARD HEADER-->
        <span class="extra-large-text">{{ greeting }}</span>
        <ng-container *ngIf="firstName$ | async as firstName; else punc">
          <span class="extra-large-text">, {{ firstName }}!</span>
        </ng-container>
        <ng-template #punc>
          <span class="extra-large-text">!</span>
        </ng-template>
        <p class="large-text margin-top-large margin-bottom-large">
          It's a great day to learn something new - explore our catalog and get started today!
        </p>
        <!--END USER DASHBOARD HEADER-->

        <!-- USER DASHBOARD ANNOUNCEMENT -->
        <ng-container *ngIf="userDashboardAnnouncement">
          <section class="dashboard-announcement-section margin-top-offset">
            <div class="wrapper">
              <div class="dashboard-announcement">
                <h1 class="visually-hidden">{{ userDashboardAnnouncement.title }}</h1>
                <app-static-page
                  [title]="''"
                  [hiddenTitle]="userDashboardAnnouncement.title"
                  [bodyContent]="userDashboardAnnouncement.content | safe : 'html'">
                </app-static-page>
              </div>
            </div>
          </section>
        </ng-container>
        <!--END USER DASHBOARD ANNOUNCEMENT-->

        <!-- INFORMATION BANNER -->
        <section
          class="information-banner-section"
          *ngIf="!isLoadingSubscription && (showRoleBasedBox || showFreeLearningBox)">
          <div class="wrapper">
            <!-- ROLE-BASED LEARNING PATH BOX -->
            <ng-container *ngIf="showRoleBasedBox">
              <div class="dashboard-announcement">
                <app-information-banner
                  [id]="roleBasedLearningPathContent?.slug"
                  [icon]="roleBasedLearningPathContent?.acf?.icon_class"
                  [title]="roleBasedLearningPathContent?.title"
                  [bodyText]="roleBasedLearningPathContent?.acf?.short_description"
                  [actionLabel]="roleBasedLearningPathContent?.acf?.cta_button_label"
                  [customClass]="'margin-top-small line-height-small vertical-banner'"
                  [queryParams]="clearSearchResults()"
                  [isFlex]="false"
                  [route]="roleBasedLearningPathContent?.acf?.route_url"
                  [routeType]="routeTypes.EXTERNAL"
                  [display]="roleBasedLearningPathContent?.acf?.display_notification"
                  [flexDirection]="'column'">
                </app-information-banner>
              </div>
            </ng-container>

            <!-- FREE LEARNING CONTENT BOX -->
            <ng-container *ngIf="showFreeLearningBox">
              <div class="dashboard-announcement">
                <app-information-banner
                  [id]="freeLearningContent?.slug"
                  [icon]="freeLearningContent?.acf?.icon_class"
                  [title]="freeLearningContent?.title"
                  [bodyText]="freeLearningContent?.acf?.short_description"
                  [actionLabel]="freeLearningContent?.acf?.cta_button_label"
                  [customClass]="'margin-top-small line-height-small vertical-banner'"
                  [queryParams]="clearSearchResults()"
                  [isFlex]="false"
                  [route]="freeLearningContent?.acf?.route_url"
                  [routeType]="routeTypes.EXTERNAL"
                  [display]="freeLearningContent?.acf?.display_notification"
                  [flexDirection]="'column'">
                </app-information-banner>
              </div>
            </ng-container>
          </div>
        </section>
        <!-- END INFORMATION BANNER -->

        <!--NOTE: Dashboard Progress and Certification are in responsive tile layout-->
        <div class="tile-layout-2">
          <!--USER DASHBOARD PROGRESS-->
          <app-dashboard-progress
            [currentUser]="this.currentUser"
            [isLoading]="this.isLoadingSubscription"></app-dashboard-progress>
          <!--USER DASHBOARD PROGRESS-->

          <!--END DASHBOARD CERTIFICATION-->
          <app-dashboard-certifications></app-dashboard-certifications>
          <!--END DASHBOARD CERTIFICATION-->
        </div>
      </div>
    </section>
  </div>
</ng-template>
<!--END DASHBOARD PAGE-->
